<template>
  <div class="moduleTwo" :style="styleObject">
    <slot></slot>
    <el-container style="height: 50%;margin: auto 0">
      <el-aside style="width: 35%">
        <div>
          <img :src="mod2.aboutImg" />
        </div>
      </el-aside>
      <el-main style="text-ailgn: left">
        <div v-html="mod2.aboutContent"></div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  props: ["mod2"],
  data() {
    return {
      styleObject: {
        height: ""
      }
    };
  },
  mounted() {
    this.innerHeight();
  },
  methods: {
    innerHeight() {
      this.styleObject.height = (window.innerHeight / 6) * 3 + "px";
      // console.log(this.styleObject, "mod2");
    }
  }
};
</script>

<style lang="sass">
.moduleTwo
  white-space: normal
  word-break: break-all;overflow:hidden
  text-align: left
  padding: 0 100px
  .el-aside
    overflow: unset
    background-color: none
    color: #333
    text-align: center
    height: 100%
    div
      height: 100%
      img
        width: 100%
        height: 100%
        box-shadow: 0 0 15px #4E4E4E
        padding: 2px
  .el-main
    color: #333
    text-align: center
    margin: auto;
    margin-left: 30px
    width: 65%
  body > .el-container
    margin-bottom: 40px
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside
    line-height: 260px
  .el-container:nth-child(7) .el-aside
    line-height: 320px
</style>
